import {apiAxios} from "@/service/APIClient";

export const bonuses = {
    dailyClaim: async (): Promise<void> => {
        let resp = await apiAxios({
            url: `/bonuses/daily/claim`,
            method: 'POST',
        })
    },
}